import { useEffect, useState } from "react";
import { Card, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchLeads } from "../Leads/leadThunk";
import { fetchDeals } from "../Deals/dealThunk";
import TaskTabs from "../TodayTasks";
import { selectAuthInfo } from "../../Auth/authSelectors";

const MyWork = () => {
  const dispatch = useDispatch();
  const authInfo = useSelector(selectAuthInfo)

  const userId = authInfo?.userInfo?.user_id;

  const { list: leads } = useSelector((s) => s.leads);
  const { list: deals } = useSelector((s) => s.deals);

  useEffect(() => {
    if (!userId) return;

    dispatch(fetchLeads({ assigned_to: userId }));
    dispatch(fetchDeals({ assigned_to: userId }));
  }, [userId]);

  return (
    <div className="p-4">
      <Row gutter={16}>
        
        {/* Tasks */}
        <Col span={24}>
          <TaskTabs />
        </Col>

        {/* My Leads */}
        <Col span={12}>
          <Card title="My Leads">
            {leads.map((l) => (
              <div key={l.id}>{l.name} - {l.phone}</div>
            ))}
          </Card>
        </Col>

        {/* My Deals */}
        <Col span={12}>
          <Card title="My Deals">
            {deals.map((d) => (
              <div key={d.deal_id}>{d.title}</div>
            ))}
          </Card>
        </Col>

      </Row>
    </div>
  );
};

export default MyWork;